import {Title} from '@mantine/core';
import type {FC} from 'react';
import {
  isReleasedAiToDoCreationFlow,
  isReleasedCareerAdviser,
} from '../../../../../../config/unReleasePage';
import type {SortOptionValue} from '../../../../constants/sort';
import {ProgressSort} from '../../Progress/ProgressSort';
import {AddEntryButton} from './AddEntryButton';
import {AiTodoGenerateButton} from './AiTodoGenerateButtonWithTooltip';
import {CompanySearch} from './CompanySearch';
import {InterviewTrainingLink} from './InterviewTrainingLink';
import {ReminderText} from './ReminderText';

type Props = {
  reminderTexts: string[];
  companyList: string[];
  companySearchWord: string;
  onCompanySearchChange: (value: string) => void;
  onCompanySearchSubmit?: (value: string) => void;
  onSort: (sort: SortOptionValue) => void;
  /** ログイン状態をチェックし、未ログイン時はモーダルを表示する */
  requireAuth?: () => boolean;
  onAddEntry: () => void;
  onAiTodoGenerate?: () => void;
};

export const ProgressPageHeader: FC<Props> = ({
  reminderTexts,
  companyList,
  companySearchWord,
  onCompanySearchChange,
  onCompanySearchSubmit,
  onSort,
  requireAuth,
  onAddEntry,
  onAiTodoGenerate,
}) => {
  return (
    <div className="flex flex-col gap-8 bg-white px-16 py-24 rounded-16">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Title order={1} className="text-xl">
            選考管理
          </Title>
        </div>
        <div className="flex items-center gap-16">
          <ProgressSort handleSort={onSort} requireAuth={requireAuth} />
          <CompanySearch
            companyList={companyList}
            value={companySearchWord}
            onChange={onCompanySearchChange}
            onSubmit={onCompanySearchSubmit}
            variant="pc"
          />
          {isReleasedCareerAdviser() && <InterviewTrainingLink />}
          {isReleasedAiToDoCreationFlow() && onAiTodoGenerate && (
            <AiTodoGenerateButton onClick={onAiTodoGenerate} isLarge />
          )}
          <AddEntryButton onClick={onAddEntry} variant="pc" />
        </div>
      </div>
      <ReminderText texts={reminderTexts} />
    </div>
  );
};
